import { makeStyles } from "@material-ui/core";
import { grey } from '@material-ui/core/colors';

export const useHomeStyle = makeStyles((theme) => ({

    indicator: {
        backgroundColor: 'white',
        height: 2.5,
    },

    bottomNavigationAction: {
        color: grey[500],
        fontWeight: 600,
        '&.Mui-selected': {
            color: grey[300],
        }
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}));